document.addEventListener('DOMContentLoaded', function () {
    const productTitle = document.querySelector('.product-meta__title');
    const productSize = document.querySelector('.product-form__case');
    const originalTitle = productTitle.textContent;
    const originalSize = productSize.textContent;

    function updateElements() {
        const optionRadios = document.querySelectorAll('.product-form__option-radio');
        let titleUpdated = false;
        let sizeUpdated = false;

        optionRadios.forEach((option) => {
            if (option.checked) {
                const variantTitle = option.getAttribute('data-metafiled-variant-title');
                const variantSize = option.getAttribute('data-metafiled-variant-pack-size');
                if (variantTitle) {
                    productTitle.textContent = variantTitle;
                    titleUpdated = true;
                }

                if (variantSize) {
                    productSize.textContent = variantSize;
                    sizeUpdated = true;
                }
            }
        });


        if (!titleUpdated) {
            productTitle.textContent = originalTitle;
        }

        if (!sizeUpdated) {
            productSize.textContent = originalSize;
        }

        productTitle.classList.remove('hidden');
    }

    function updatedActiveColor() {
        const optionRadios = document.querySelectorAll('.product-form__option-radio');
        const productOptions = document.querySelectorAll('[data-option-visible]'); 

        productOptions.forEach((productOption) => productOption.classList.remove('color-active'));

        optionRadios.forEach((option) => {
            if (option.checked) {
                const parent = option.closest('.product-form__option-grid-item');
                let variantId = parent.dataset.variantId;


                let matchedProductOption = [...productOptions].find((productOption) => 
                    productOption.dataset.variantId === variantId
                );


                if(matchedProductOption) {
                    matchedProductOption.classList.add('color-active');
                }

            }
        });
    }

    updateElements();
    updatedActiveColor();

    document.querySelectorAll('.product-form__option-radio').forEach(function (radio) {
        radio.addEventListener('change', updateElements);
        radio.addEventListener('change', updatedActiveColor);

    });
});


window.onload = function () {
	updateElements();
}





